import axios from 'axios';
import config from 'api/urls-config.json';

export const getSearch = params => {
    const { search, language, country } = params;

    return axios.get(`${config.API + config.search}`, {
        params: {
            language,
            country,
            search,
        },
    });
};
